import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import VisibilityIcon from "@mui/icons-material/Visibility";
import TableCard from "../../components/TableCard";
import GroupsIcon from "@mui/icons-material/Groups";
import { useContext, useEffect, useState } from "react";
import {
  buscarUsuariosPorIdPai,
  reenviarEmailToken,
  buscarPdfPrevia,
  aprovarCadastro,
  reprovarCadastro,
} from "../../services/api-planejamento-tributario.service";
import { LoginContext } from "../../config/Context/LoginContext";
import styles from "./styles.module.css";
import ModalVisualizar from "./ModalVisualizar";
import PeopleIcon from "@mui/icons-material/People";
import PersonIcon from "@mui/icons-material/Person";
import { Fab, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { keyframes } from "@emotion/react";
import { useNavigate } from "react-router-dom";
import { CadastroContext } from "../../config/Context/CadastroContext";
import ModalEmailParceiro from "./ModalEmailParceiro";
import { styled } from "@mui/material/styles";
import SpeedDial from "../../components/SpeedDial";
import Loading from "../../components/Loading";
import SnackBar from "../../components/SnackBar";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import ModalPreviewPrevia from './ModalPreviewPrevia';

const formatCPF = (cpf) => {
  if (!cpf) return "-";
  const cleaned = cpf.replace(/\D/g, "");
  return cleaned.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
};

const formatCNPJ = (cnpj) => {
  if (!cnpj) return "-";
  const cleaned = cnpj.replace(/\D/g, "");
  return cleaned.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
    "$1.$2.$3/$4-$5"
  );
};

const pulse = keyframes`
0% {
  transform: scale(1);
}
50% {
  transform: scale(1.1);
}
100% {
  transform: scale(1);
}
`;

const Vinculos = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [openVisualizar, setOpenVisualizar] = useState(false);
  const [dadosUsuarios, setDadosUsuarios] = useState({ id: "", tipo: "" });
  const [dadosFiltrados, setDadosFiltrados] = useState([]);
  const [openEmail, setOpenEmail] = useState(false);
  const [openPreview, setOpenPreview] = useState(false);
  const [previewId, setPreviewId] = useState(null);
  const { dadosLogin } = useContext(LoginContext);
  const { dados, setDados } = useContext(CadastroContext);
  const [objSnackBar, setObjSnackBar] = useState({ type: "", msg: "" });
  const navigate = useNavigate();

  const handleClick = (id, tipo) => {
    setOpenVisualizar(true);
    setDadosUsuarios({ id, tipo });
  };

  const handleCloseVisualizar = () => {
    setOpenVisualizar(false);
  };

  const handleCloseEmail = () => {
    setOpenEmail(false);
  };

  const handleOpenPreview = (idOrObj) => {
    setPreviewId(idOrObj);
    setOpenPreview(true);
  };
  const handleClosePreview = () => {
    setPreviewId(null);
    setOpenPreview(false);
  };

  const handlePesquisaPorTexto = (value) => {
    const newValue = value.toLowerCase();

    const filtered = data.filter((item) =>
      Object.keys(item).some((key) =>
        item[key].toString().toLowerCase().includes(newValue)
      )
    );
    setDadosFiltrados(filtered);
  };

  const handleOrganiza = (dados) => {
    const dadosOrganizados = dados.map((item) => {
      const dtCadastro = new Date(item.dt_cadastro).toLocaleDateString();
      let botoes = [];
      let novoStatus;
      switch (item.status) {
        case "APROVADO":
          novoStatus = (
            <span className={styles.status_container}>
              <span className={styles.aprovado} /> Aprovado
            </span>
          );
          break;
        case "ANALISANDO_CLIENTE":
        case "CADASTRARDET":
          botoes = [
            {
              icon: <VisibilityIcon />,
              title: "VISUALIZAR",
              onClick: () => handleClick(item.id, item.tipo),
            },
          ];
          novoStatus = (
            <span className={styles.status_container}>
              <span className={styles.analise} /> Análise Simples
            </span>
          );
          break;
        case "REPROVADO":
          novoStatus = (
            <span className={styles.status_container}>
              <span className={styles.reprovado} /> Reprovado
            </span>
          );
          break;
        case "ANALISANDO":
          botoes = [
            {
              icon: <VisibilityIcon />,
              title: "VISUALIZAR",
              onClick: () => handleClick(item.id, item.tipo),
            },
          ];
          novoStatus = (
            <span className={styles.status_container}>
              <span className={styles.revisando} /> Revisando
            </span>
          );
          break;
        case "USUARIO_PENDENTE":
          botoes = [
            {
              icon: <SettingsBackupRestoreIcon />,
              title: "REENVIAR",
              onClick: () => handleReenviarEmailToken(item.id),
            },
          ];
          novoStatus = (
            <span className={styles.status_container}>
              <span className={styles.user_pendente} /> Usuário Pendente
            </span>
          );
          break;
        case "PREVIA-PENDENTE":
          botoes = [
            {
              icon: <VisibilityIcon />,
              title: "VISUALIZAR",
              onClick: () => handleClick(item.id, item.tipo),
            },
            {
              icon: <PictureAsPdfIcon />, // abrir modal de prévia
              title: "PRÉVIA",
              onClick: () => {
                // usar CNPJ para buscar o idPrevia no backend
                const cnpj = item?.cnpj || item?.cnpj_filtrado || item?.cnpjFormatado || null;
                if (!cnpj) {
                  handleSnackBar({ type: 'error', msg: 'CNPJ não encontrado para este registro; não é possível buscar prévia.' });
                  return;
                }
                // passar objeto que a service aceitará, incluindo idCliente para ações de aprovação/reprovação
                handleOpenPreview({ cnpj, idCliente: item.id });
              },
            },
          ];
          novoStatus = (
            <span className={styles.status_container}>
              <span className={styles.analise} /> Prévia Pendente
            </span>
          );
          break;

        default:
          break;
      }
      return {
        tipo: item.tipo ?? "-",
        nome: item.nome ?? "-",
        cpf: item.cpf ? formatCPF(item.cpf) : "-",
        cnpj:
          item.cnpj && item.cnpj !== "undefined" ? formatCNPJ(item.cnpj) : "-",
        dtCadastro,
        status: item.status ? novoStatus : "-",
        botoes,
      };
    });
    setData(dadosOrganizados);
    setDadosFiltrados(dadosOrganizados);
    setLoading(false);
  };

  const handleNavigate = (tipo) => {
    switch (tipo) {
      case "cliente":
        setDados({ ...dados, tipo: "C" });
        navigate("/cadastrar-cnpj");
        break;
      case "parceiro":
        setOpenEmail(true);
        break;

      default:
        break;
    }
  };

  const handleSnackBar = (obj) => {
    setObjSnackBar(obj);
  };

  useEffect(() => {
    const fetch = async () => {
      const response = await buscarUsuariosPorIdPai(
        dadosLogin.tipoCadastroPlanTribKey,
        dadosLogin.idUsuario
      );
      handleOrganiza(response.usuarios);
    };
    fetch();
  }, []);

  const handleReenviarEmailToken = async (idCliente) => {
    try {
      const response = await reenviarEmailToken({ idCliente });
      handleSnackBar({
        type: "success",
        msg: response.data.message || "Email reenviado com sucesso.",
      });
    } catch (error) {
      handleSnackBar({
        type: "error",
        msg: "Erro ao reenviar o email com token. Tente novamente.",
      });
    }
  };

  const actions = [
    {
      icon: <PersonIcon />,
      name: "Clientes",
      onClick: () => handleNavigate("cliente"),
    },
    {
      icon: <PeopleIcon />,
      name: "Parceiros",
      onClick: () => handleNavigate("parceiro"),
    },
  ];

  const optionsFilter = [
    { value: "status: Aprovado" },
    { value: "status: Reprovado" },
    { value: "status: Analisando" },
    { value: "status: Revisando" },
  ];

  const columns = ["Tipo", "Nome", "CPF", "CNPJ", "Data Cadastro", "Status"];
  return (
    <>
      <TableCard
        iconHeader={
          <GroupsIcon fontSize="1rem" sx={{ marginRight: ".5rem" }} />
        }
        titleHeader="Vinculos"
        optionsFilter={optionsFilter}
        data={dadosFiltrados}
        setData={setDadosFiltrados}
        columns={columns}
        loading={loading}
        textHeaderCard="nome"
        handleDebounce={handlePesquisaPorTexto}
      />
      <ModalVisualizar
        open={openVisualizar}
        onClose={handleCloseVisualizar}
        dadosUsuarios={dadosUsuarios}
      />
      {dadosLogin.tipoCadastroPlanTribKey === "A" ? (
        <SpeedDial actions={actions} />
      ) : (
        <Fab
          sx={{
            background: "#4b6fc0",
            bottom: 40,
            right: 20,
            position: "fixed",
            zIndex: 1000,
            animation: `${pulse} 1.5s infinite ease-in-out`,
            "&:hover": {
              backgroundColor: "#4b6fc0",
            },
          }}
          aria-label="add"
          onClick={() => handleNavigate("cliente")}
        >
          <AddIcon sx={{ color: "#fff" }} />
        </Fab>
      )}
      <ModalEmailParceiro openModal={openEmail} onClose={handleCloseEmail} />
      <ModalPreviewPrevia open={openPreview} onClose={handleClosePreview} id={previewId} handleSnackBar={handleSnackBar} />
      <SnackBar objSnackBar={objSnackBar} setObjSnackBar={handleSnackBar} />
    </>
  );
};

export default Vinculos;
